import { DefaultFooter } from '@ant-design/pro-components';

const Footer: React.FC = () => {
  const defaultMessage =
    ' 广州未来一手网络运营有限公司 地址：广州市南沙区丰泽东路106号（自编1号楼）';

  const currentYear = new Date().getFullYear();

  return (
    <DefaultFooter
      style={{
        background: 'none',
        paddingBottom: '12px',
        marginTop: '24px',
      }}
      copyright={`${currentYear} ${defaultMessage}`}
      links={[
        {
          key: '粤ICP备2022101711号',
          title: `备案号：粤ICP备2022101711号`,
          href: 'https://beian.miit.gov.cn/#/Integrated/index',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
